export default __webpack_public_path__ + "static/media/UC.1fe9efd8.png";